<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-etg-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-etg-' + id"
    :aria-controls="'collapse-etg-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_ETG") }}
  .collapse.show(
    :aria-labelledby="'heading-etg-' + id"
    :id="'collapse-etg-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group(v-for="item in col1")
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_" + item) }}
              template(v-if="moreItems['etgo'][item] && moreItems['etgo'][item][5] != 0 && moreItems['etgo'][item][5] != ''")
                OddsItem(:odds="moreItems['etgo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="etgo")
              template(v-else)
                OddsDisabled
        .normal(v-if="$helpers.objSize(moreItems['etgho']) > 0 && (mode == 0 || mode == 2)")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-group(v-for="item in col2")
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_" + item) }}
              template(v-if="moreItems['etgho'][item] && moreItems['etgho'][item][5] != 0 && moreItems['etgho'][item][5] != ''")
                OddsItem(:odds="moreItems['etgho'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="etgho")
              template(v-else)
                OddsDisabled



</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col1: ["0", "1", "2", "3", "4", "5", "6Up"],
      col2: ["0", "1", "2", "3Up"],
    }
  }
}
</script>